import React from 'react';
import {Route, Switch, withRouter} from "react-router-dom";
import classes from 'classnames';
import PropTypes from 'prop-types';
import routerConfig from '../../config/router';

import Header from '../Header';
import Footer from '../Footer';
import Home from '../Home';
import Auth from '../Auth';
import VendorMain from '../Vendor';
import Profile from '../Profile';
import SearchResult from '../SearchResult';
import TourPage from '../TourPage';
import Cart from '../Cart';
import Booking from '../Booking';
import OrderList from '../UserOrders/List'
import OrderDetails from '../UserOrders/OrderDetails';
import ResetPassword from '../ResetPassword';
import Registration from '../Auth/components/register';
import ErrorPayment from '../Error/errorPayment';
import ContactUs from '../StaticPages/ContactUs';
import AboutUs from '../StaticPages/AboutUs';
import Err404 from '../Error/404';
import Bg from './components/Bg';

import './Main.scss';

class Main extends React.Component {

  static propTypes = {
    onMainClick: PropTypes.func,
    auth: PropTypes.object,
    getAllCities: PropTypes.func,
    getCategories: PropTypes.func,
    getUserInfo: PropTypes.func,
    history: PropTypes.object
  };

  static defaultProps = {
    auth: {},
  };

  componentWillMount() {
    this.props.getAllCities();
    setTimeout(() => {
      this.props.getCategories();
      setTimeout(() => {
        this.props.getUserInfo();
      }, 100)
    }, 100)
  }

  render() {

    const {
      auth,
      onMainClick,
      history,
    } = this.props;

    const className = classes('wrapper wrapper_main', {home: history.location.pathname === '/'});

    return (
      <main
        className="main"
        onClick={onMainClick}
        role="presentation"
        onKeyDown={() => {
        }}
      >
        <Header />
        {
          auth.isShow ?
            <Auth
              auth={auth}
            /> : null
        }
        <div className={className}>
          <Switch>
            <Route
              exact
              path={routerConfig.home}
              component={Home}
            />
            <Route
              path={routerConfig.register}
              component={Registration}
            />
            <Route
              path={`${routerConfig.searchResult}/:id?`}
              component={SearchResult}
            />
            <Route
              path={`${routerConfig.tourPage}/:id?`}
              component={TourPage}
            />
            <Route
              path={routerConfig.vendor.home}
              component={VendorMain}
            />
            <Route
              path={routerConfig.profile}
              component={Profile}
            />
            <Route
              path={routerConfig.cart}
              component={Cart}
            />
            <Route
              path={routerConfig.booking}
              component={Booking}
            />
            <Route
              exact
              path={routerConfig.ordersList}
              component={OrderList}
            />
            <Route
              exact
              path={`${routerConfig.orderDetails}/:id`}
              component={OrderDetails}
            />
            <Route
              path={routerConfig.errorPayment}
              component={ErrorPayment}
            />
            <Route
              path={`${routerConfig.resetPassword}/:hash`}
              component={ResetPassword}
            />
            <Route
              path={routerConfig.aboutUs}
              component={AboutUs}
            />
            <Route
              path={routerConfig.contactUs}
              component={ContactUs}
            />
            <Route
              component={Err404}
            />
          </Switch>
        </div>
        <Bg
        />
        <Footer />
      </main>
    )
  }
}

export default withRouter(Main);


// WEBPACK FOOTER //
// ./src/app/containers/Main/Component.js